import { render } from "./Tappable.vue?vue&type=template&id=fc77c70e"
import script from "./Tappable.vue?vue&type=script&lang=js"
export * from "./Tappable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__